import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sid = params.get("session_id");
    if (!sid) {
      navigate("/login");
      return;
    }
    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sid });
        if (data?.session_token) localStorage.setItem("session_token", data.session_token);
        setUser(data.user);
        window.history.replaceState({}, "", "/");
        navigate(data.user.role === "admin" ? "/admin" : "/", { state: { user: data.user } });
      } catch (e) {
        navigate("/login?err=1");
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <div className="label-tiny">Accesso in corso</div>
        <div className="font-serif text-3xl mt-2">un istante…</div>
      </div>
    </div>
  );
}
